import React from "react";

import { TimePicker, TimePickerProps } from "@mui/x-date-pickers";

import { Dayjs } from "dayjs";

export interface TimeFieldProps {
  value: Dayjs | null;
  onChange?: (date: Dayjs | null) => void;
  timePickerProps?: TimePickerProps<Dayjs>;
}

const TimeField: React.FC<TimeFieldProps> = ({
  value,
  onChange,
  timePickerProps,
}) => {
  return (
    <TimePicker
      slotProps={{
        textField: {
          size: "small",
          sx: { bgcolor: "backgrond.paper" },
        },
      }}
      value={value}
      onChange={onChange}
      {...timePickerProps}
    />
  );
};

export default TimeField;
